import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { Web3Service } from '@/services/web3.service';
import { environment } from 'src/environments/environment';

@Pipe({
  standalone: true,
  name: 'starterBid'
})

export class StarterBidPipe implements PipeTransform {

  constructor(
    private web3Svc: Web3Service,
    private decimal: DecimalPipe
  ) {}

  transform(tokenId: number | string): string {
    if (!tokenId && tokenId !== 0) return '0';
    const ethPrice = environment.auctionStarterValue + '.' + String(tokenId).padStart(4, '0');
    const weiPrice = this.web3Svc.ethToWei(Number(ethPrice));
    return weiPrice.toString();
  }
}
